// extracted by mini-css-extract-plugin
export default {"search-bar":"SearchBar_search-bar__JFw-V","search-bar__input":"SearchBar_search-bar__input__p4Hq5","search-bar__icon":"SearchBar_search-bar__icon__AwTsG"};